import { DetailedHTMLProps, HTMLAttributes } from "react";

import { useLanguage } from "~/contexts/providers/language";
import { TagType } from "~/types/tag/tag.types";

import MainButton from "../../common/mainButton";
import styles from "./index.module.scss";

type Props = DetailedHTMLProps<
  HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  tags: TagType[];
  filter: TagType[];
  relative?: boolean;
  handleSetFilter: (filter: TagType) => void;
  handleResetFilter?: () => void;
};

const TagFilter = ({
  tags,
  filter,
  className,
  relative = true,
  handleSetFilter,
  handleResetFilter,
}: Props) => {
  const { language } = useLanguage();

  return (
    <div
      className={[
        relative ? styles.relativeFilter : styles.genericFilter,
        className,
      ].join(" ")}
    >
      {handleResetFilter && (
        <MainButton
          key={0}
          className={[
            styles.item,
            filter.length === 0 ? styles.selected : undefined,
          ].join(" ")}
          onClick={() => {
            handleResetFilter();
          }}
        >
          {language === "En" ? "All" : "Tout"}
        </MainButton>
      )}
      {tags.map((tag) => (
        <MainButton
          key={tag.id}
          className={[
            styles.item,
            filter.includes(tag) ? styles.selected : undefined,
          ].join(" ")}
          onClick={() => {
            handleSetFilter(tag);
          }}
        >
          {tag[`name${language}`]}
        </MainButton>
      ))}
    </div>
  );
};

export default TagFilter;
